// This file is deprecated - use ../utils/axiosConfig instead
import api from "../utils/axiosConfig";
export default api;
